module.exports = __webpack_public_path__ + "static/media/industry_icon3.b5ff71e4.svg";